var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "download-app" }, [
    _c("h2", [_vm._v(_vm._s(_vm.$t("message.footer.download_apps")))]),
    _vm._v(" "),
    _vm._m(0)
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("ul", { staticClass: "download-app-list list-unstyled" }, [
      _c("li", [
        _c(
          "a",
          {
            attrs: {
              href: "https://itunes.apple.com/th/app/beneat/id1203611695?mt=8",
              target: "_blank"
            }
          },
          [
            _c("img", {
              attrs: {
                height: "76",
                alt: "Line BeNeat",
                src: "/static/img/btn-app-store.svg"
              }
            })
          ]
        )
      ]),
      _vm._v(" "),
      _c("li", [
        _c(
          "a",
          {
            attrs: {
              href:
                "https://play.google.com/store/apps/details?id=com.beneat.app",
              target: "_blank"
            }
          },
          [
            _c("img", {
              attrs: {
                height: "76",
                alt: "Line BeNeat",
                src: "/static/img/btn-play-store.svg"
              }
            })
          ]
        )
      ])
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3e4a2f3d", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3e4a2f3d","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/others/DownloadApp.vue
// module id = 2004
// module chunks = 0